import axios from "axios";
import AlertStore from '@/stores/AlertStore'
import hasPermission from "../filters/hasPermission";
import {
  ENDPOINT_MARCHE_SECURITE_CHANTIERS,
  ENDPOINT_MARCHE_SECURITE_CHANTIERS_VALIDATE,
  ENDPOINT_MOIS_PRECEDENTS,
  ENDPOINT_SEARCH,
  ENDPOINT_EXPORT,
  ENDPOINT_MOIS_MANQUANTS,
  ENDPOINT_MARCHE_SECURITE_CHANTIERS_REJECT
} from "../constants/endpoints";

let store = {
  debug: true,

  get(id) {
    return axios
        .get(ENDPOINT_MARCHE_SECURITE_CHANTIERS + '/' + id)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  create(securiteChantiers) {
    return axios
        .post(ENDPOINT_MARCHE_SECURITE_CHANTIERS, securiteChantiers)
        .then(() => {
          this.clearLocalStorage();
          AlertStore.pushSuccess('Données d\'accidentologie créées avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  update(securiteChantiers) {
    return axios
        .put(ENDPOINT_MARCHE_SECURITE_CHANTIERS, securiteChantiers)
        .then(() => {
          const isAdmin = hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR']);
          const correspondantSecuriteMsg = "Modification de données d'accidentologie soumise pour approbation.";
          const adminMsg = "Données d'accidentologie modifiées avec succès.";
          const successMessage = isAdmin || !securiteChantiers.jourSoumissionPassed ? adminMsg : correspondantSecuriteMsg;
          AlertStore.pushSuccess(successMessage);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  getMissingMonths(marcheId, date) {
    return axios
        .get(ENDPOINT_MARCHE_SECURITE_CHANTIERS + ENDPOINT_MOIS_MANQUANTS, {params: {marcheId, date}})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  getPreviousMonths(marcheId, date) {
    return axios
        .get(ENDPOINT_MARCHE_SECURITE_CHANTIERS + ENDPOINT_MOIS_PRECEDENTS, {params: {marcheId, date}})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  delete(securiteChantiers) {
    return axios
        .delete(ENDPOINT_MARCHE_SECURITE_CHANTIERS + '/' + securiteChantiers.id)
        .then(() => {
          const isAdmin = hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR']);
          const correspondantSecuriteMsg = "Suppression de données d'accidentologie soumise pour approbation.";
          const adminMsg = "Données d'accidentologie supprimées avec succès.";
          const successMessage = isAdmin || securiteChantiers.statut === 'ATTENTE_MODIFICATION' || !securiteChantiers.jourSoumissionPassed ? adminMsg : correspondantSecuriteMsg;
          AlertStore.pushSuccess(successMessage);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  search(securiteChantiers, pageIndex, pageSize, sortOptions) {
    const recherche = this.marcheSecuriteToRecherche(securiteChantiers);
    let url = `${ENDPOINT_MARCHE_SECURITE_CHANTIERS + ENDPOINT_SEARCH}?page=${pageIndex}&size=${pageSize}`;
    if (sortOptions) {
      for (const sortOption of sortOptions) {
        url += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`;
      }
    }
    return axios
        .post(url, recherche);
  },

  export(securiteChantiers) {
    const recherche = this.marcheSecuriteToRecherche(securiteChantiers);
    let url = `${ENDPOINT_MARCHE_SECURITE_CHANTIERS + ENDPOINT_EXPORT}`;
    return axios
        .post(url, recherche);
  },

  validate(securiteChantiers) {
    return axios
        .post(ENDPOINT_MARCHE_SECURITE_CHANTIERS_VALIDATE + '/' + securiteChantiers.id)
        .then(() => {
          const operation = securiteChantiers.statut === 'ATTENTE_MODIFICATION' ? 'modification' : 'suppression';
          AlertStore.pushSuccess(`Demande de ${operation} de données d'accidentologie approuvée avec succès.`);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  reject(id, commentaire) {
    return axios.post(`${ENDPOINT_MARCHE_SECURITE_CHANTIERS_REJECT}/${id}`, {
      message: commentaire
    })
      .then((response) => {
        if (response.status === 204) {
          AlertStore.pushSuccess('La demande de données d\'accidentologie a été rejetée avec succès.')
        }
      }).catch((error) => {
        console.log(error)
        AlertStore.pushError('La demande de données d\'accidentologie n\'a pas pu être rejetée.')
      })
  },

  marcheSecuriteToRecherche(marcheSecurite) {
    let recherche = [];
    recherche.push({key: 'marche', operation: '=', value: marcheSecurite.marche});
    recherche.push({key: 'ligne', operation: '=', value: marcheSecurite.ligneId});
    recherche.push({key: 'statut', operation: '€', value: marcheSecurite.statut});
    recherche.push({key: 'date', operation: '>=', value: marcheSecurite.dateDebut});
    recherche.push({key: 'date', operation: '<=', value: marcheSecurite.dateFin});
    return recherche;
  },
  clearLocalStorage() {
    localStorage.removeItem('securiteChantiers');
    localStorage.removeItem('dateSecuriteChantiers');
    localStorage.removeItem('marcheAdminSecuriteChantiers');
  }

};

export default store;
